export type DesignDocumentStatus = "pending_signature" | "signed" | "rejected";

export type DocumentApprovalStatus = "pending_approval" | "approved" | "rejected" | "withdrawn";

export type ClusterSigningMode = "electronic" | "paper";

export type ClusterType = "designer_signature" | "director_acceptance";

export interface ManagedFileBrief {
  id: string;
  original_filename: string;
  content_type: string;
  size_bytes: number;
  url: string | null;
}

export interface DesignDocumentRevision {
  id: string;
  revision_number: number;
  reason: string;
  status: DesignDocumentStatus;
  original_file: ManagedFileBrief | null;
  signed_file: ManagedFileBrief | null;
  created_by: string | null;
  created_by_name: string | null;
  signed_at: string | null;
  acknowledged_at: string | null;
  acknowledged_by: string | null;
  rejected_by: string | null;
  rejected_by_name: string | null;
  rejected_at: string | null;
  rejection_reason: string;
  created_at: string;
  updated_at: string;
}

export interface DesignDocument {
  id: string;
  cluster_id: string;
  title: string;
  quantity: number;
  approval_status: DocumentApprovalStatus;
  approved_by: string | null;
  approved_by_name: string | null;
  approved_at: string | null;
  rejected_by: string | null;
  rejected_by_name: string | null;
  rejected_at: string | null;
  rejection_reason: string;
  withdrawn_by: string | null;
  withdrawn_by_name: string | null;
  withdrawn_at: string | null;
  withdrawal_reason: string;
  can_withdraw: boolean;
  current_status: DesignDocumentStatus | null;
  revisions: DesignDocumentRevision[];
  created_by: string | null;
  notes: string | null;
  can_edit_notes: boolean;
  created_at: string;
  updated_at: string;
}

export interface ClusterSignatureTypeDetail {
  id: string;
  name: string;
  unit: string;
  is_free: boolean;
  rate: string | null;
}

export interface ClusterMember {
  id: string;
  user_id: string;
  full_name: string;
  role: string;
  added_by_name: string | null;
  created_at: string;
}

export interface DocumentationCluster {
  id: string;
  project: string;
  contractor: string | null;
  employee_signer: string | null;
  employee_agreement: string | null;
  signature_type: string | null;
  employee_signer_name: string | null;
  signature_type_detail: ClusterSignatureTypeDetail | null;
  signer_kind: "contractor" | "employee" | "director" | "unknown";
  cluster_type: ClusterType;
  reviewing_director: string | null;
  reviewing_director_name: string | null;
  project_name: string;
  contractor_name: string | null;
  created_by: string | null;
  created_by_name: string | null;
  name: string;
  description: string;
  signing_mode: ClusterSigningMode;
  document_count: number;
  pending_count: number;
  pending_approval_count: number;
  unacknowledged_count: number;
  total_quantity: number;
  is_settled: boolean;
  settled_at: string | null;
  settled_by_name: string | null;
  settlement_note: string;
  can_delete: boolean;
  can_edit: boolean;
  can_unsettle: boolean;
  members: ClusterMember[];
  can_manage_members: boolean;
  created_at: string;
  updated_at: string;
}

export const CLUSTER_TYPE_LABELS: Record<ClusterType, string> = {
  designer_signature: "Podpis projektanta",
  director_acceptance: "Akceptacja dyrektora",
};

export const STATUS_LABELS: Record<DesignDocumentStatus, string> = {
  pending_signature: "Oczekuje na sprawdzenie",
  signed: "Sprawdzone",
  rejected: "Odrzucone",
};

export const STATUS_COLORS: Record<DesignDocumentStatus, "amber" | "green" | "red"> = {
  pending_signature: "amber",
  signed: "green",
  rejected: "red",
};
